import { render, staticRenderFns } from "./IntegralConfig.vue?vue&type=template&id=d2f70190&scoped=true&"
import script from "./IntegralConfig.vue?vue&type=script&lang=js&"
export * from "./IntegralConfig.vue?vue&type=script&lang=js&"
import style0 from "./IntegralConfig.vue?vue&type=style&index=0&id=d2f70190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f70190",
  null
  
)

export default component.exports